<template>
    <div class="nav-header">
        <!--
        <div class="top-header">
            <div>
                <span>图标-超链接</span>
            </div>
            <div class="a-link">
                <span v-for="i in [1, 2, 3, 4, 5]" :key="i">超链接{{ i }}</span>
            </div>
        </div>
        -->

        <div class="menu-navigation">
            <div>
                <img src="/images/logo.jpg" style="width: 80px; margin-left: 15px;">
                <span style="margin-left: 10px; font-size: 26px;"><a href='/'
                        style="color: white; text-decoration: none;">GENEasso</a></span>
            </div>
            <div class="menu-box">

                <router-link class="menu-item" v-for="menu in menuList" :key="menu.path" :to="menu.path" :custom="true"
                    v-slot="{ href, navigate }">
                    <a v-if="!menu.children" :href="href" @click="onLinkClick($event, navigate, menu.path)">
                        <i :class="menu.svgIcon"></i>
                        <span>{{ menu.title }}</span>
                    </a>
                    <el-dropdown v-if="menu.children">
                        <span class="el-dropdown-link">
                            {{ menu.title }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>

                        <el-dropdown-menu slot="dropdown" >
                            <el-dropdown-item v-for="child in menu.children">
                                <router-link class="menu-item" :key="child.path" :to="child.path" :custom="true"
                                    v-slot="{ href, navigate }">
                                    <a :href="href" @click="onLinkClick($event, navigate, child.path)" class="sub-link">
                                        <span>{{ child.title }}</span>
                                    </a>
                                </router-link>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </router-link>
            </div>
        </div>

        <div class="nav-breadcrumb" v-if="$route.name !== 'home'">
            <router-link to="/">Home</router-link>
            <template v-if="isBrowse">
                <span class="cut">/</span>
                <router-link v-if="isBrowse" to="/browse">browse</router-link>
            </template>
            <span class="cut">/</span>
            <span>{{ breadcrumb }}</span>
        </div>
    </div>
</template>

<script>

const menuList = [
    {
        svgIcon: "glyphicon glyphicon-home",
        title: "Home",
        path: "/home",
    },
    /*
    {
        svgIcon: "glyphicon glyphicon-eye-open",
        title: "Browse",
        path: "/browse",
    },
     */
    {
        svgIcon: "glyphicon glyphicon-list",
        title: "Disease",
        path: "/browseTraits",
    },
    {
        svgIcon: "glyphicon glyphicon-leaf",
        title: "Gene",
        path: "/browseGenes",
    },
    {
        svgIcon: "glyphicon glyphicon-search",
        title: "Search",
        path: "/search",
    },
    {
        svgIcon: "glyphicon glyphicon-download-alt",
        title: "Downloads",
        path: "/downloads",
    },
    {
        svgIcon: "glyphicon glyphicon-indent-left",
        title: "Analysis",
        path: "",
        children: [
            {
                title: "Analysis & Comparison",
                path: "/twas"
            },
            {
                title: "Trait-specific Tissue Calculation",
                path: "/tissue"
            },
            {
                title: "Job Search",
                path: "/results"
            }
        ]
    },
    {
        svgIcon: "glyphicon glyphicon-file",
        title: "Tutorial",
        path: "/tutorial",
    }
]

export default {
    name: "nav-header",

    data() {
        return {
            menuList,
        };
    },

    computed: {
        breadcrumb() {
            return this.$route.meta?.title;
        },
        isBrowse() {
            let d = [
                "trait",
                "genedetail",
                "publication",
            ];
            return d.includes(this.$route.name);
        },
    },

    methods: {
        onLinkClick(e, navigate, url) {
            if (url.indexOf('/dagena') >= 0) {
                e.preventDefault()
                return;
            }
            navigate(e);
        },
        goto(url) {
            this.$router.push({
                path: url
            })
        },
    },
};
</script>

<style lang="less" scoped>
/deep/ a {
    color: white;
    text-decoration: none;
}

/deep/ a:hover, a:active, a:focus {
    color: white;
}

.sub-link {
    color: black;
    text-decoration: none;
}

.sub-link:hover {
    color: black;
}

.nav-header {
    .top-header {
        height: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #2a6240;
        color: #ffffff;

        .a-link {
            span {
                margin-right: 16px;
            }
        }
    }

    .menu-navigation {
        color: #ffffff;
        height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #2a6240;

        .menu-box {
            padding-right: 20px;

            .menu-item {
                color: #ffffff;
                display: inline-block;
                padding: 6px 9px;
                font-size: 17px;

                span {
                    //font-size: 20px;
                }

                i {
                    margin-right: 8px;
                }

                &:not(:last-child) {
                    border-right: 1px solid #ffffff;
                }
            }
        }
    }

    .nav-breadcrumb {
        height: 40px;
        display: flex;
        align-items: center;
        padding-left: 16px;
        background: #f4f4f4;
        font-size: 16px;
        font-weight: bold;
        color: #176b6e;

        a {
            color: #176b6e;

            &:hover {
                text-decoration: underline;
            }
        }

        .cut {
            content: "/";
            padding: 5px 5px 0;
        }
    }

    .el-dropdown-link {
        cursor: pointer;
        color: white;
        font-size: 18px;
    }

    .el-icon-arrow-down {
        font-size: 18px;
    }
}
</style>
